import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { IonRow,  IonButton, IonCol, IonLabel, IonInput, IonCheckbox, IonTitle, IonToolbar, IonButtons, IonIcon, IonContent,} from "@ionic/angular/standalone";
import { AgGridModule } from "ag-grid-angular";
import { IonicModule,  } from "@ionic/angular";

const modules = [
  CommonModule,
  FormsModule,
  // IonicModule,
  IonButtons,
  IonIcon,
  IonContent,
  IonToolbar,
  IonTitle,
  IonRow,
  IonCol,
  IonLabel,
  IonButton,
  IonInput,
  IonCheckbox,
  AgGridModule
];


@NgModule({
  // standalone:true,
  imports: [...modules],
  exports: [...modules],
})
export class SharedModule {}
